import chevronDownIcon from '@jetbrains/icons/chevron-down.svg'
import * as React from 'react'

import {
  useIsAgentsPartSelected,
  useIsChangesSelected,
  useIsGuidesOverviewSelected,
  useIsQueueSelected,
} from '../../../../hooks/routes'
import {usePermission} from '../../../../hooks/usePermission'
import {getIsSakuraUI} from '../../../../selectors'
import {Permission, ROOT_PROJECT_ID} from '../../../../types'
import LinkWithIcon from '../../../common/LinkWithIcon/LinkWithIcon'
import SvgIcon from '../../../common/SvgIcon/SvgIcon'
import {createRootSubprojectLink} from '../../../pages/ProjectPage/ProjectPageHeader/ProjectCreateSection/ProjectCreateSection'
import {LINKS} from '../Header.constants'

import HeaderLinkHost from './Links.host'
import {isActiveClassicUILink} from './Links.utils'

import styles from './Links.css'

import {useAppSelector} from 'src/hooks/react-redux'

const SubprojectCreateLink = React.memo(() => {
  const canCreateSubproject = usePermission(Permission.CREATE_SUB_PROJECT, ROOT_PROJECT_ID)

  return canCreateSubproject ? (
    <LinkWithIcon
      href={createRootSubprojectLink}
      title={'Create subproject'}
      aria-label={'Create subproject'}
      icon={'add'}
      className={styles.addProject}
    />
  ) : null
})

SubprojectCreateLink.displayName = 'Header Create Subproject Link'

function ProjectsLink() {
  const agentsPartSelected = useIsAgentsPartSelected()
  const queuePartSelected = useIsQueueSelected()
  const changesPartSelected = useIsChangesSelected()
  const guidesOverviewSelected = useIsGuidesOverviewSelected()
  const isSakuraUI = useAppSelector(getIsSakuraUI)
  const active = React.useMemo(
    () =>
      isSakuraUI
        ? !agentsPartSelected &&
          !queuePartSelected &&
          !changesPartSelected &&
          !guidesOverviewSelected
        : isActiveClassicUILink('overview'),
    [
      isSakuraUI,
      agentsPartSelected,
      queuePartSelected,
      changesPartSelected,
      guidesOverviewSelected,
    ],
  )
  return (
    <div className={styles.container}>
      <HeaderLinkHost
        className={styles.link}
        active={active}
        title={'Projects'}
        to={LINKS.overview}
      >
        {'Projects'}
      </HeaderLinkHost>
      {!isSakuraUI && (
        <SvgIcon className={styles.projectsPopup} id={'allPopupImg'} icon={chevronDownIcon} />
      )}
      {isSakuraUI && <SubprojectCreateLink />}
    </div>
  )
}
export default React.memo(ProjectsLink)
